enum ActionType {
    REQUEST_TREND = '[DASHBOARD/ETS_TREND] GET ETS TREND',
    RECEIVE_TREND = '[DASHBOARD/ETS_TREND] SET ETS TREND',
    TREND_REQUEST_FAILED = '[DASHBOARD/ETS_TREND] ETS TREND REQUEST FAILED',
}

export default ActionType
